import PropTypes from 'prop-types';
import {generateTipCountLabel} from '../simpleTransferTaskHelper';

function TaskPickTipDescription({rowTipCount, columnTipCount, showCaddyNumber, caddyNumber}) {
  return (
    <>
      &nbsp;
      <span>from Tip Caddy {showCaddyNumber ? `#${caddyNumber}` : ''}</span>
      &nbsp;
      <span className="green">{generateTipCountLabel(rowTipCount, columnTipCount)}</span>
    </>
  );
}

TaskPickTipDescription.propTypes = {
  rowTipCount: PropTypes.string,
  columnTipCount: PropTypes.string,
  showCaddyNumber: PropTypes.bool.isRequired,
  caddyNumber: PropTypes.number.isRequired,
};

TaskPickTipDescription.defaultProps = {
  columnTipCount: '',
  rowTipCount: '',
};

export default TaskPickTipDescription;
